import { DialogTitle, DialogContent, Grid, IconButton, Modal, DialogActions, Button, Box } from "@mui/material";
import { IResource, ResourceType } from "store/types";
import { styled } from "styled-components";
import { grey6 } from "theme/colors";
import CloseIcon from "@mui/icons-material/Close";
import { useCallback } from "react";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const parse = require("html-react-parser");

interface IProps {
  resource: IResource;
  open: boolean;
  onClose: any;
}

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: 600,
  width: 800,
  bgcolor: "#FFFFFF",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "8px",
  p: 4,
};

const PageTitle = styled.legend`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
`;

const ResourceDescription = styled.p`
  color: ${grey6.toString()};
`;

const LabelPreviewPanel = styled.div`
  width: 100%;
  height: 400px;
  overflow-x: auto;
  overflow-y: auto;
`;

export const ResourcePreview = ({ resource, open, onClose }: IProps) => {
  const showPreview = useCallback(() => {
    switch (resource.type && resource.type.toLowerCase().trim()) {
      case ResourceType.LABEL.toLowerCase():
        return <LabelPreviewPanel>{parse(resource.content)}</LabelPreviewPanel>;
      case ResourceType.IMAGE.toLowerCase():
        return (
          <img
            src={resource.content}
            style={{ alignSelf: "center" }}
            width="100"
            height="50"
            alt={resource.description}
          />
        );
      case ResourceType.PAGE.toLowerCase():
      case ResourceType.URL.toLowerCase():
      case ResourceType.FORUM.toLowerCase():
      case ResourceType.LTI.toLowerCase():
      case ResourceType.QUIZ.toLowerCase():
      case ResourceType.RESOURCE.toLowerCase():
      case ResourceType.ASSIGNMENT.toLowerCase():
      case ResourceType.FEEDBACK.toLowerCase():
        return (
          <iframe
            src={resource.content}
            title={resource.description}
            height="400"
            width="750"
            style={{ pointerEvents: "none" }}
          ></iframe>
        );
      case ResourceType.VIDEO.toLowerCase():
        return (
          <iframe
            width="560"
            height="315"
            src={resource.content}
            title={resource.description}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        );
      default:
        return <i>Preview not available.</i>;
    }
  }, [resource.content, resource.description, resource.type]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="resource-preview-title"
      aria-describedby="resource-preview-description"
    >
      <Box sx={style}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Grid container>
            <Grid item xs={11} style={{ display: "flex", alignItems: "center" }}>
              <PageTitle>Preview</PageTitle>
            </Grid>
            <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  color: "#414141",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <ResourceDescription>{resource.description}</ResourceDescription>
          {showPreview()}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </DialogActions>
      </Box>
    </Modal>
  );
};
